module.exports = __webpack_public_path__ + "img/form_action.af8435f7.svg";